exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/course-notifications-v2.js-WebpackMultiOutput";